export const metaphiUrl = 'https://metaphi.xyz';
